<p class="seo-text-insert">
  <ng-content></ng-content>
</p>
